export enum Workspace {
  attorney = 'attorney',
  marketeer = 'marketeer',
}
